import {
  createTechDocsAddonExtension,
  TechDocsAddonLocations,
} from '@backstage/plugin-techdocs-react';
import { techdocsExtensionPlugin } from '../../../plugin';
import { MermaidAddon, MermaidProps } from './components';

export const Mermaid = techdocsExtensionPlugin.provide(
  createTechDocsAddonExtension<MermaidProps>({
    name: 'MermaidDiagram',
    location: TechDocsAddonLocations.Content,
    component: MermaidAddon,
  }),
);
